<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-material-card
      icon="mdi-clipboard-text"
      class="px-5 py-3"
      :title="'Visitas del proyecto: ' + proyecto.codigo + ' - ' + proyecto.nombre"
    >
      <v-timeline
        v-if="proyecto.visitas!==undefined"
        align-top
        justify="center"
        dense
      >
        <div
          v-for="(visita, n) in proyecto.visitas.slice().reverse()"
          :key="n"
        >
          <v-timeline-item
            v-if="visita.eficaz=='Sí'"
            color="teal lighten-3"
            justify-center
            small
          >
            <v-row class="pt-1">
              <v-col cols="3">
                <strong>{{ visita.fecha_creacion }}</strong>
              </v-col>
              <v-col>
                <strong>{{ visita.asunto }}</strong>
                <div class="text-caption mb-2">
                  Comentario: {{ visita.comentario }}
                </div>
                <div class="text-caption mb-2">
                  Eficacia: {{ visita.eficaz }}
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
          <v-timeline-item
            v-else
            color="pink"
            small
          >
            <v-row class="pt-1">
              <v-col cols="3">
                <strong>{{ visita.fecha_creacion }}</strong>
              </v-col>
              <v-col>
                <strong>{{ visita.asunto }}</strong>
                <div class="text-caption mb-2">
                  Comentario: {{ visita.comentario }}
                </div>
                <div class="text-caption mb-2">
                  Eficacia: {{ visita.eficaz }}
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </div>
      </v-timeline>
      <div
        v-else
        class="text-center card-title font-weight-light mb-3"
      >
        No se han registrado visitas
      </div>
    </base-material-card>
  </v-container>
</template>
<script>
  import firebase from 'firebase'
  const db = firebase.firestore()
  export default ({
    data () {
      return {
        proyecto: null,
      }
    },
    mounted () {
      if (this.$store.state.prospectarData === null) {
        this.$router.push('/proyectos/')
      }
      this.getItem(this.$store.state.prospectarData)
    },
    methods: {
      getItem (item) {
        var docRef = db.collection('proyectos').doc(item.codigo)
        docRef.get().then((doc) => {
          this.proyecto = doc.data()
        }).catch(() => {
        })
      },
    },
  })
</script>
